// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import store from './store'
import "../static/animate.min.css";
import 'babel-polyfill'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import axios from 'axios'
Vue.prototype.$axios = axios
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Base64 from '../src/api/base64'

Vue.prototype.$Base64 = Base64;



// Vue.prototype.axios = axios.create({
//     headers: { 'content-type': 'application/x-www-form-urlencoded' }
// });
// Vue.use(axios);
import filters from "./common/filter/filter"//用于处理浮点数小数位数
//全局方法Vue.filter()统一注册自定义过滤器
Object.keys(filters).forEach(key => {//返回filters对象中属性名组成的数组
    Vue.filter(key, filters[key])
})

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.component('VueSlider', VueSlider)


new Vue({
    el: '#app',
    router,
    store,// 这样就能全局使用vuex了
    components: {
        App
    },
    template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js